import { FILTER_TYPES } from './filterType';

export const RECURRING_MODES = {
  NO_RECURRING: 'no_recurring',
  RECURRING_ALLOWED: 'recurring_allowed',
  RECURRING_ONLY: 'recurring_only',
};

export const MEMBERSHIPS_PERIODICITIES = {
  LIFELONG: 'none',
  ONE_DAY: 'one_day',
  TWO_DAY: 'two_days',
  THREE_DAY: 'three_days',
  WEEK: 'week',
  FIFTEEN_DAYS: 'fifteen_days',
  MONTH: 'month',
  TWO_MONTHS: 'two_months',
  THREE_MONTHS: 'three_months',
  SIX_MONTHS: 'six_months',
  YEAR: 'year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  FOUR_YEARS: 'four_years',
  FIVE_YEARS: 'five_years',
};

export const MEMBERSHIPS_YEARLY_RECURRING_PERIODICITIES = [
  MEMBERSHIPS_PERIODICITIES.YEAR,
  MEMBERSHIPS_PERIODICITIES.TWO_YEARS,
  MEMBERSHIPS_PERIODICITIES.THREE_YEARS,
  MEMBERSHIPS_PERIODICITIES.FOUR_YEARS,
  MEMBERSHIPS_PERIODICITIES.FIVE_YEARS,
];

export const MEMBERSHIPS_TAGS = [
  {
    id: 1,
    name: FILTER_TYPES.NETWORK,
    label: s__('Memberships|Network Memberships'),
  },
  {
    id: 2,
    name: FILTER_TYPES.GROUP,
    label: s__('Memberships|Group Memberships'),
  },
  {
    id: 3,
    name: FILTER_TYPES.MY_GROUPS,
    label: s__("Memberships|My Group's Memberships"),
  },
];
